/* eslint-disable no-undef */ /* eslint-disable no-unused-vars */ /* eslint-disable max-len */ 'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var body = document.body;
var page = document.documentElement;
var menu = document.getElementById('menu1');
var openMenuButton = document.getElementById('menu-button');
var closeMenuButton = document.getElementById('menu-close');
openMenuButton.addEventListener('click', function() {
    openMenu();
});
closeMenuButton.addEventListener('click', function() {
    closeMenu();
});
function openMenu() {
    menu.classList.add('menu1--open');
    body.style.overflowY = 'hidden';
// page.style.paddingRight = getScrollbarWidth() + 'px';
}
function closeMenu() {
    menu.classList.remove('menu1--open');
    body.style.overflowY = 'auto';
    page.style.paddingRight = 0;
}
// Function to get all href attributes from <a> elements in the document
function getAllHrefLinks() {
    // Use document.querySelectorAll to select all <a> elements
    var parentElement = document.getElementById('menu1');
    var links = parentElement.querySelectorAll('a');
    // Extract the href attributes into an array
    var hrefs = Array.from(links) // Convert NodeList to Array
    .map(function(link) {
        return link.getAttribute('href');
    }) // Get the href attribute
    .filter(function(href) {
        return href !== null && href.trim() !== '';
    }); // Filter out null or empty hrefs
    return hrefs;
}
// Example usage
var allLinks = getAllHrefLinks();
document.addEventListener('click', function(e) {
    var target = e.target;
    var targetId = target.getAttribute('href');
    var targetElement = document.querySelector(targetId);
    if (allLinks.some(function(element) {
        return element === targetId;
    })) {
        e.preventDefault();
        closeMenu();
        if (targetElement) targetElement.scrollIntoView({
            behavior: 'smooth'
        });
    }
});
var language = document.getElementById('language');
var openLanguageButton = document.querySelector('.language-link');
var closeLanguageButton = document.getElementById('language-close');
function openLanguage() {
    language.classList.add('language--open');
    body.style.overflowY = 'hidden';
// page.style.paddingRight = getScrollbarWidth() + 'px';
}
function closeLanguage() {
    language.classList.remove('language--open');
    body.style.overflowY = 'auto';
    page.style.paddingRight = 0;
}
openLanguageButton.addEventListener('click', function() {
    openLanguage();
});
closeLanguageButton.addEventListener('click', function() {
    closeLanguage();
});
language.addEventListener('click', function(e) {
    if (e.target.closest('li')) closeLanguage();
    e.stopPropagation();
});
document.addEventListener('click', function(e) {
    if (!language.contains(e.target) && language.classList.contains('language--open') && e.target !== openLanguageButton) closeLanguage();
});
var dropdown = document.querySelector('.dropdown');
var dropdownBtn = document.querySelector('.dropdown__btn');
var dropdownContent = document.querySelector('.dropdown__content');
var options = dropdownContent.querySelectorAll('li');
dropdownBtn.addEventListener('click', function() {
    dropdown.classList.toggle('dropdown--active');
});
document.addEventListener('click', function(event) {
    if (!dropdown.contains(event.target)) dropdown.classList.remove('dropdown--active');
});
options.forEach(function(option) {
    option.addEventListener('click', function() {
        dropdownBtn.textContent = this.textContent;
        dropdown.classList.remove('dropdown--active');
    });
});
var help = document.getElementById('help');
var openHelpButtons = document.querySelectorAll('.help-link');
var closeHelpButton = document.getElementById('help-close');
var helpServiceBtn = help.querySelectorAll('.help__service-btn');
function openHelp() {
    help.classList.add('help--open');
    body.style.overflowY = 'hidden';
// page.style.paddingRight = getScrollbarWidth() + 'px';
}
function closeHelp() {
    help.classList.remove('help--open');
    body.style.overflowY = 'auto';
    page.style.paddingRight = 0;
}
openHelpButtons.forEach(function(btn) {
    return btn.addEventListener('click', function() {
        openHelp();
    // pageMenuContent;
    });
});
closeHelpButton.addEventListener('click', function() {
    closeHelp();
});
helpServiceBtn.forEach(function(btn) {
    return btn.addEventListener('click', function() {
        closeHelp();
    });
});
var faq = document.getElementById('faq');
var openFaqButtons = document.querySelectorAll('.faq-link');
var closeFaqButton = document.getElementById('faq-close');
function openFaq() {
    faq.classList.add('faq--open');
    body.style.overflowY = 'hidden';
// page.style.paddingRight = getScrollbarWidth() + 'px';
}
function closeFaq() {
    faq.classList.remove('faq--open');
    body.style.overflowY = 'auto';
    page.style.paddingRight = 0;
}
openFaqButtons.forEach(function(btn) {
    return btn.addEventListener('click', function() {
        openFaq();
    });
});
closeFaqButton.addEventListener('click', function() {
    closeFaq();
});
var accordions = document.querySelectorAll('.accordion');
accordions.forEach(function(accordion) {
    accordion.addEventListener('click', function() {
        this.classList.toggle('accordion--open');
    });
});
if (window.innerWidth >= 1280) {
    // eslint-disable-next-line no-shadow
    var swiper = new Swiper('.swiper-header', {
        loop: true,
        autoplay: {
            delay: 5000
        },
        navigation: {
            prevEl: '.slider__navigation--prev',
            nextEl: '.slider__navigation--next'
        },
        scrollbar: {
            el: '.header__swiper-scrollbar',
            dragClass: 'header__swiper-scrollbar-drag'
        }
    });
}
var swiper1 = new Swiper('.about__swiper', {
    loop: true,
    autoplay: {
        delay: 5000
    },
    navigation: {
        prevEl: '.slider__navigation--prev',
        nextEl: '.slider__navigation--next'
    },
    scrollbar: {
        el: '.about__swiper-scrollbar',
        dragClass: 'about__swiper-scrollbar-drag'
    },
    pagination: {
        el: '.about__swiper-pagination--bullet',
        clickable: true,
        bulletActiveClass: 'about__swiper-pagination-bullet-active',
        bulletClass: 'about__swiper-pagination-bullet'
    },
    breakpoints: {
        1280: {
            pagination: {
                el: '.about__slider-pagination--fraction',
                type: 'fraction',
                currentClass: 'pagination-current',
                totalClass: 'pagination-total'
            }
        }
    }
});
var techSpecButtons = document.querySelectorAll('.tech__spec-button');
techSpecButtons.forEach(function(button) {
    button.addEventListener('click', function() {
        var parent = button.closest('.tech__spec');
        var info = parent.querySelector('.tech__spec-info');
        var specButton = parent.querySelector('.tech__spec-button');
        info.classList.toggle('tech__spec-info--show');
        specButton.classList.toggle('tech__spec-button--active');
    });
});
var frm = document.forms.contact__form;
var name1 = frm.name;
var nameLabel = document.querySelector('label[for="name1"]');
var nameLabelText = nameLabel.innerText;
var email = frm.email;
var emailLabel = document.querySelector('label[for="email"]');
var emailLabelText = emailLabel.innerText;
var phone = frm.phone;
var phoneLabel = document.querySelector('label[for="phone"]');
var phoneLabelText = phoneLabel.innerText;
var submitBtn = document.querySelector('.form__submit-btn');
frm.addEventListener('submit', function(e) {
    e.preventDefault();
    var err = false;
    if (!name1.value) {
        nameField.setError(nameField.msg);
        err = true;
    }
    if (!email.value) {
        emailField.setError(emailField.msg);
        err = true;
    }
    if (!phone.value) {
        phoneField.setError(phoneField.msg);
        err = true;
    }
    if (err) return;
    var elements = _to_consumable_array(frm.elements);
    elements.forEach(function(element) {
        element.disabled = true;
    });
    var btnText = submitBtn.firstElementChild;
    var text = btnText.innerText;
    btnText.innerText = '';
    wait().then(function() {
        frm.reset();
    }).finally(function() {
        elements.forEach(function(element) {
            element.disabled = '';
        });
        btnText.innerText = text;
    });
});
function wait(delay) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, delay);
    });
}
var Field = /*#__PURE__*/ function() {
    function Field(input, label, labelText, msg) {
        _class_call_check(this, Field);
        this.input = input;
        this.label = label;
        this.labelText = labelText;
        this.errMsg = '';
        this.msg = msg;
    }
    _create_class(Field, [
        {
            key: "setError",
            value: function setError(msg) {
                this.label.innerText = msg;
                this.label.style.color = '#860404';
                this.input.style.borderBottomColor = '#860404';
            }
        },
        {
            key: "clearError",
            value: function clearError() {
                this.label.innerText = this.labelText;
                this.label.style.color = '';
                this.input.style.borderBottomColor = '';
            }
        }
    ]);
    return Field;
}();
var nameField = new Field(name1, nameLabel, nameLabelText, 'Please, fill your name*');
var emailField = new Field(email, emailLabel, emailLabelText, 'Please, fill your email*');
var phoneField = new Field(phone, phoneLabel, phoneLabelText, 'Please, fill your phone*');
var createHandlers = function(field) {
    field.input.addEventListener('blur', function(e) {
        if (!e.target.value.trim()) field.setError(field.msg);
    });
    field.input.addEventListener('input1', function() {
        field.clearError();
    });
};
createHandlers(nameField);
createHandlers(emailField);
createHandlers(phoneField);
// Get references to the video and button elements
var playButton = document.getElementById('playButton');
var buttonsPlay = document.querySelectorAll('.my-button-play');
var existingIframe = document.getElementById('myIframe');
var closeButton = document.getElementById('close-button');
var videoContainer = document.getElementById('video-container');
// Add a click event listener to the button
buttonsPlay.forEach(function(button, index) {
    button.addEventListener('click', function() {
        videoContainer.append(existingIframe);
        videoContainer.style.display = 'block';
        if (index === 0) videoContainer.style.top = '130px';
        else if (index === 1) {
            if (window.innerWidth > 1280) videoContainer.style.top = '1380px';
            else if (window.innerWidth > 768) videoContainer.style.top = '1130px';
            else if (window.innerWidth <= 768) videoContainer.style.top = '1530px';
        }
    });
});
// playButton.addEventListener('click', () => {
//  videoContainer.append(existingIframe);
// Check if the video is paused
/*
  const newIframe = document.createElement('iframe'); // Create new iframe

  newIframe.id = 'myIframe';

  newIframe.src
      = 'https://www.youtube.com/embed/SvTbB19bvIw?si=l7gxztTxlRT-R5oJ'; // Set iframe source
  newIframe.title = 'YouTube video player';
  newIframe.className = 'video';

  newIframe.allow
      = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  newIframe.referrerPolicy = 'strict-origin-when-cross-origin';
  newIframe.allowFullscreen = 'true';

  videoContainer.appendChild(newIframe); */ // videoContainer.style.display = 'block';
// });
// Get references to the video player and close button
// Add event listener to the close button
closeButton.addEventListener('click', function() {
    // Hide the video container
    // Call the function to pause the video
    // closeIFrame();
    // existingIframe.remove();
    if (player) stopVideo(); // Stops the video
    closeIFrame();
    videoContainer.style.display = 'none';
});
function closeIFrame() {
    if (existingIframe) existingIframe.remove();
}
// Dynamically load the YouTube Iframe API script
var tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
// document.head.appendChild(tag);
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
// Load the YouTube Iframe API
var player;
function onYouTubeIframeAPIReady() {
    player = new YT.Player('myIframe', {
        videoId: 'SvTbB19bvIw?si=l7gxztTxlRT-R5oJ',
        playerVars: {
            'playsinline': 1,
            'autoplay': 1,
            'controls': 1
        },
        events: {
            'onReady': onPlayerReady(),
            'onStateChange': onPlayerStateChange()
        }
    });
}
function onPlayerReady(event) {
    videoContainer.style.borderColor = '#0760c5ff';
    event.target.playVideo();
    if (event.data === YT.PlayerState.PLAYING) videoContainer.style.borderColor = '#dfee0dff';
}
// let done = false;
function onPlayerStateChange(event) {
    /* if (event.data === YT.PlayerState.PLAYING && !done) {
    done = true;
    stopVideo();
  } */ if (event.data === YT.PlayerState.PLAYING) videoContainer.style.borderColor = '#dfee0dff';
    // const embedCode = event.target.getVideoEmbedCode();
    // const state = player.getPlayerState();
    // const statusText = getPlayerStateText(state);
    var st = event.data;
    changeBorderColor(st);
}
function changeBorderColor(status) {
    var color;
    if (status === -1) color = '#37474F'; // unstarted = gray
    else if (status === 0) color = '#FFFF00'; // ended = yellow
    else if (status === 1) color = '#33691E'; // playing = green
    else if (status === 2) color = '#DD2C00'; // paused = red
    else if (status === 3) color = '#AA00FF'; // buffering = purple
    else if (status === 5) color = '#FF6DOO'; // video cued = orange
    if (color) videoContainer.style.borderColor = color;
}
function stopVideo() {
    player.stopVideo();
}
document.getElementById('form-pay').addEventListener('submit', function(e) {
    e.preventDefault();
    document.getElementById('pay').scrollIntoView({
        behavior: 'smooth'
    });
    var formData = new FormData(this);
    fetch('/submit-url', {
        method: 'POST',
        body: formData
    }).then(function(response) {
        if (response.ok) // eslint-disable-next-line no-console
        console.log('Form sent succesfully!');
    });
});
document.getElementById('go-to-pay').addEventListener('click', function(e) {
    var form = document.getElementById('form-place-order');
    if (form.checkValidity()) window.location.href = '#pay';
    else form.reportValidity();
    e.preventDefault();
});
var quantityPay = document.getElementById('quantity-pay');
var quantityPlace = document.getElementById('quantity-place-order');
quantityPay.addEventListener('change', function() {
    quantityPlace.value = quantityPay.value;
});
quantityPlace.addEventListener('change', function() {
    quantityPay.value = quantityPlace.value;
});
if (quantityPay && quantityPlace) {
    quantityPay.addEventListener('change', function() {
        quantityPlace.value = quantityPay.value;
    });
    quantityPlace.addEventListener('change', function() {
        quantityPay.value = quantityPlace.value;
    });
}
var inputs = document.querySelectorAll('.form__input--card');
inputs.forEach(function(input, index) {
    input.addEventListener('input', function() {
        input.value = input.value.replace(/\D/g, '');
        if (input.value.length === 4 && index < inputs.length - 1) inputs[index + 1].focus();
    });
});
var expiryInput = document.getElementById('expiry');
expiryInput.addEventListener('input', function(e) {
    var value = e.target.value.replace(/[^\d]/g, ''); // digits only
    var cursorPosition = expiryInput.selectionStart;
    if (value.length > 4) value = value.slice(0, 4); // 4 digits max
    if (value.length > 2) value = value.slice(0, 2) + '/' + value.slice(2);
    expiryInput.value = value;
    if (cursorPosition === 3 && !value.includes('/')) expiryInput.setSelectionRange(4, 4); // after insert "/"
});
var cvvInput = document.getElementById('cvv');
cvvInput.addEventListener('input', function(e) {
    e.target.value = e.target.value.replace(/\D/g, ''); // digits only
});

//# sourceMappingURL=layout_KateVR.c8a2bc20.js.map
